import { useState, useEffect, useContext } from "react";
import {
  wallet,
  transactionHistory,
  // trantransactionHistoryfilter,
  getGraphData,
  addCreadits,
} from "../../assets/Js/script";
import {
  Page,
  Navbar,
  BtnBlock,
  DialogBox,
  BtnSmall,
  Loader,
  PopUp,
} from "../../components";
import { AuthContext } from "../../context/auth";
import razorpay from "../../assets/Js/payment";
import moment from "moment";
import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
// import faker from 'faker';


export default function Wallet() {
  const { user } = useContext(AuthContext);

  const [modals, setModals] = useState({
    addCredit: false,
    tranDetail: false,
    transDetailType: false,
  });

  const [graphData, SetGraphData] = useState([]);

  const [paymentSuccessfull, setPaymentSuccessfull] = useState(false);
  const [flterSort, setFilterSort] = useState(false);
  const [filterYear, setFilterYear] = useState(false);
  const [renderYear, setRenderYear] = useState('')
  const [pageNation, setPageNation] = useState(1);
  const [pageNationMsg, setPageNationMsg] = useState("");
  const [totalPage, setTotalPage] = useState(1);
  const [filterData, setFilterData] = useState("View all");
  const [filterDataTwo, setFilterDataTwo] = useState("View all");
  const [filterByType, setFilterByType] = useState("");
  const [filterByTypeTwo, setFilterByTypeTwo] = useState("");
  const [filterByDate, setFilterByData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [transaction, setTransaction] = useState();
  const [credit, setCredit] = useState();
  const [inputValue, setInputValue] = useState(100);
  const [creditOption, setCreditOption] = useState([
    { amount: 2500, selected: true },
    { amount: 5000, selected: false },
    { amount: 10000, selected: false },
    { amount: 15000, selected: false },
    { amount: 20000, selected: false },
  ]);
  const [pickedHistory, setPickedHistory] = useState(null);
  const [year, setYear] = useState([]);
  const [filterValue, setFilterValue] = useState([
    "Tokens Added by Publisher",
    "Hosting Charge",
    "Book Conversion",
    "Generate Access IDs",
    // "Book Renewals",
    // "Book Reactivation",
    // "Order ID Renewal",
    "Tokens of Unused Access IDs",
    "ePrakashak Tokens Credit",
    "View all",
  ]);
  let divStyle = 'calc(100% - 354px)'
  const [filterValueTwo, setFilterValueTwo] = useState([
    "Three Mon",
    "Six Months",
    "One Year",
    "View all",
  ])

  function changeData(data) {
    setFilterData(data);
    switch (data) {
      case "View all":
        {
          setFilterByType("");
          setPageNation(1);
        }
        break;

      case "Tokens Added by Publisher":
        {
          setFilterByType("creditsByPublisher");
          setPageNation(1);
        }
        break;

      case "Hosting Charge":
        {
          setFilterByType("hostingCharge");
          setPageNation(1);
        }
        break;

      case "Book Conversion":
        {
          setFilterByType("bookConversion");
          setPageNation(1);
        }
        break;

      case "Generate Access IDs":
        {
          setFilterByType("generateAccessIds");
          setPageNation(1);
        }
        break;

      case "Book Renewals":
        {
          setFilterByType("bookRenewal");
          setPageNation(1);
        }
        break;

      case "Book Reactivation":
        {
          setFilterByType("bookReactivation");
          setPageNation(1);
        }
        break;

      case "Order ID Renewal":
        {
          setFilterByType("creditsByPlb");
          setPageNation(1);
        }
        break;

      case "Tokens of Unused Access IDs":
        {
          setFilterByType("addUnusedAccessIds");
          setPageNation(1);
        }
        break;
        case "ePrakashak Tokens Credit":
        {
          setFilterByType("ePrakashak Tokens Credit");
          setPageNation(1);
        }
        break;
    }
  }
  function changeDataTwo(data) {
    setFilterDataTwo(data);
    switch (data) {
      case "View all":
        {

          setFilterByType("");
          setPageNation(1);
        }
        break;

      case "Three Months":
        {
          setFilterByData("threeMonths");
          setPageNation(1);
        }
        break;

      case "Six Months":
        {
          setFilterByData("sixMonths");
          setPageNation(1);
        }
        break;

      case "One Year":
        {
          setFilterByData("oneYear");
          setPageNation(1);
        }
        break;
    }
  }
  function changeYear(data) {
    setRenderYear(data);
  }

  function prevPaginationPage() {
    if (pageNation == 1) {
      return false;
    } else {
      setPageNation((curr) => curr - 1);
    }
  }
  function nextPaginationPage() {
    if (totalPage / 5 <= pageNation) {
      return false;
    } else {
      setPageNation((curr) => curr + 1);
    }
  }

  useEffect(() => {
    const call = async () => {
      const { response } = await wallet();
      if (response.status === "success") {
        setCredit({ ...response.data });
        setIsLoading(false);
      }
    };
    call();
    const graph = async () => {

      const { response } = await getGraphData(renderYear);
      if (response.status === "success") {
        SetGraphData([...response.data.charges])
        setIsLoading(false);
      }
    };
    graph();
  }, [paymentSuccessfull, renderYear]);

  //--------------

  async function addcreaditsinacc() {
    const { response, error } = await addCreadits(inputValue);
    if (response.status === "success") {
      setIsLoading(false);
      setModals((prev) => ({ ...prev, addCredit: false }));

      razorpay(
        user,
        {
          amount: response.data.order.amount,
          id: response.data.order.id,
        },
        { paymentSuccessfull, setPaymentSuccessfull }
      );
    }
  }

  function getTime(time) {
    return moment(time).fromNow(true);
  }
  function totalPages() {
    if (totalPage) {
      const totalPageValue = Math.ceil(totalPage / 5);
      return totalPageValue;
    }
    return false;
  }
  /// api

  useEffect(() => {
    const call = async () => {
      const { response, error } = await transactionHistory(
        pageNation,
        filterByType,
        filterByDate
      );
      if (response.status === "success") {
        setTotalPage(response.data.total);

        setTransaction([...response.data.myTransactions]);
      } else {
        setPageNationMsg(response.message);
      }
    };
    call();
  }, [
    pageNation,
    pageNationMsg,
    filterByType,
    filterByDate,
    paymentSuccessfull,
  ]);

  function renderHeading(data) {
    switch (data) {
      case "hostingCharge":
        {

          return "Hosting Charges for a Book"
        }
        break;
      case "bookConversion":
        {

          return "Book Conversion Charges"
        }
        break;
      case "generateAccessID":
        {

          return " AccessIDs Generation Charges"
        }
        break;
      case "setHostingCharge":
        {

          return "Hosting Charges for a Set"
        }
        break;
      case "creditsByPublisher":
        {

          return "Tokens Added By Publisher"
        }
        break;
      case "creditsByPlb":
        {

          return "Welcome Tokens"
        }
        break;
      case "addUnusedAccessIds":
        {

          return "Buyback for Unused Access IDs"
        }
        break;

    };

    return data;
  }

  function openDetailPage(data) {
    // setIsLoading(true);
    setModals((prev) => ({ ...prev, tranDetail: true }));
    let storeData = {};
    if (
      data?.typesOfTransactions === "hostingCharge" ||
      data?.typesOfTransactions === "bookConversion"
    ) {
      setIsLoading(false);
      setModals((prev) => ({ ...prev, transDetailType: true }));
      setPickedHistory({ ...data });
    } else {
      setIsLoading(false);
      setModals((prev) => ({ ...prev, transDetailType: false }));
      setPickedHistory({ ...data });
    }
    //  return storeData;
  }

  //// graph data //////////


  // useEffect(() => {
  //   function yearFinder(){


  //   let year = new Date().getFullYear();
  //   let years = [year];
  //   let count = 5;
  //   while(count >= 0){
  //     year -= 1;
  //     years.push(year);
  //     count--
  //   }

  //   setYear([...years]);
  // };

  // yearFinder();
  // }, []);

  useEffect(() => {
    function yearFind() {
      // console.log(moment().format('yyyy'), "user");

      // console.log(moment(user.createdAt).format('yyyy'), "user");

      let currYear = moment().format('yyyy');
      let startYear = moment(user.createdAt).format('yyyy');
      let Data = [currYear];
      let counting = (currYear - startYear);
      while (counting > 0) {
        currYear -= 1
        Data.push(currYear);
        counting--
      }


      setYear([...Data]);
    };
    yearFind()
  }, [])



  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' //as const,
      },
      title: {
        display: true,
        text: 'Tokens Spend Analysis',
      },
    },
  };

  const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const data = {
    labels,
    datasets: [
      {
        label: 'totalConversionCharge',
        // data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
        data: graphData.map((elm) => elm.totalConversionCharge),
        backgroundColor: 'rgba(112, 41, 99, 1)',
      },
      {
        label: 'totalHostingCharge',
        // data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
        data: graphData.map((elm) => elm.totalHostingCharge),
        backgroundColor: 'rgba(187, 122, 175, 1)',
      },
      {
        label: 'totalAccessIdCharge',
        // data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
        data: graphData.map((elm) => elm.totalAccessIdCharge),
        backgroundColor: 'rgba(255, 214, 0, 1)',
      },
    ],
  };

  let CurrentYear = new Date().getFullYear();

  return (
    <Page active="wallet">
      <Navbar />
      {isLoading ? (
        <Loader show={isLoading} />
      ) : (
        <>
          <div className="max-w-[1400px] h-wallet flex ">
            <div className=" flex flex-col justify-between mr-6 max-w-354 h-full">
              <div className="rounded-md flex justify-between py-4 px-4 w-full h-24 bg-primary-extra-light border-primary-dark-20 border-1 border-solid">
                <div className="flex flex-col justify-between items-start">
                  <div className="flex items-center">
                    <div className="mr-4 flex justify-center items-center w-8 h-8 rounded-md bg-secondary-yellow">
                      <svg
                        width="19"
                        height="20"
                        viewBox="0 0 19 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.7382 10.9526V13.8098C16.7382 15.0479 13.9027 16.6669 10.4049 16.6669C6.90706 16.6669 4.07153 15.0479 4.07153 13.8098V11.4288"
                          stroke="white"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M4.3374 11.6755C5.12002 12.7688 7.54026 13.7945 10.4047 13.7945C13.9025 13.7945 16.7381 12.265 16.7381 10.9507C16.7381 10.2126 15.8451 9.40404 14.4436 8.83643"
                          stroke="white"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M14.0238 6.19043V9.04757C14.0238 10.2857 11.1883 11.9047 7.69051 11.9047C4.1927 11.9047 1.35718 10.2857 1.35718 9.04757V6.19043"
                          stroke="white"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7.69051 9.03254C11.1883 9.03254 14.0238 7.50302 14.0238 6.18873C14.0238 4.8735 11.1883 3.3335 7.69051 3.3335C4.1927 3.3335 1.35718 4.8735 1.35718 6.18873C1.35718 7.50302 4.1927 9.03254 7.69051 9.03254Z"
                          fill="white"
                          stroke="white"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>

                    <h2 className="text-h2 tracking-wide text-tertiary-dark font-semibold">
                      {Math.floor(credit?.myCredits?.credits)}
                    </h2>
                  </div>
                  <p className="mt-1 text-h5 font-semibold tracking-wide text-secondary-dark">
                    Total Tokens Available
                  </p>
                </div>
                {/* <div className="relative flex justify-center items-center">
                  <p className="text-xs absolute -left-4 -top-1 text-tertiary-dark flex items-center">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 14V7"
                        stroke="#702963"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15 10.0625L18 7L21 10.0625"
                        stroke="#702963"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    12%
                  </p>
                  <svg
                    width="74"
                    height="44"
                    viewBox="0 0 74 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_d_1588_5036)">
                      <path
                        d="M4.94499 35.0443L20.5948 31.6844C21.8661 31.4115 22.8168 30.3507 22.9494 29.0572L24.0858 17.9735C24.3969 14.9389 27.3296 12.8877 30.2869 13.6364L35.0833 14.8508C37.8843 15.5599 40.7015 13.7543 41.2271 10.9132L42.2103 5.59808C42.7359 2.75697 45.5531 0.951378 48.3541 1.66051L57.6743 4.02018C58.6427 4.26538 59.6625 4.21483 60.602 3.87505L69.6579 0.599808"
                        stroke="#702963"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_1588_5036"
                        x="0.840088"
                        y="0.129395"
                        width="72.9878"
                        height="43.4038"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.227451 0 0 0 0 0.137255 0 0 0 0 0.415686 0 0 0 0.48 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_1588_5036"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_1588_5036"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div> */}
              </div>
              <div className="rounded-md flex justify-between items-center py-4 px-4 w-full h-24 bg-primary-extra-light border-primary-dark-20 border-1 border-solid">
                <div className="flex flex-col justify-between items-start">
                  <div className="flex items-center">
                    <div className="mr-4 flex justify-center items-center w-8 h-8 rounded-md bg-secondary-yellow">
                      <svg
                        width="22"
                        height="20"
                        viewBox="0 0 22 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 1.11133C9.06609 1.11133 7.17565 1.63265 5.56771 2.60938C3.95976 3.5861 2.70652 4.97435 1.96646 6.59859C1.2264 8.22282 1.03277 10.0101 1.41005 11.7344C1.78733 13.4586 2.71857 15.0425 4.08602 16.2856C5.45346 17.5287 7.1957 18.3753 9.0924 18.7183C10.9891 19.0613 12.9551 18.8853 14.7417 18.2125C16.5284 17.5397 18.0555 16.4004 19.1299 14.9386C20.2043 13.4768 20.7777 11.7583 20.7777 10.0002C20.7777 7.64274 19.7476 5.38181 17.9139 3.71482C16.0802 2.04783 13.5932 1.11133 11 1.11133V1.11133ZM14.5933 6.11133H15.8888C16.0509 6.11133 16.2064 6.16986 16.321 6.27405C16.4356 6.37823 16.5 6.51954 16.5 6.66688C16.5 6.81423 16.4356 6.95553 16.321 7.05972C16.2064 7.16391 16.0509 7.22244 15.8888 7.22244H14.8255V7.32799C14.8344 7.77324 14.7465 8.2157 14.5669 8.63001C14.3873 9.04431 14.1195 9.4223 13.7789 9.74231C13.4382 10.0623 13.0314 10.318 12.5818 10.4948C12.1322 10.6716 11.6486 10.7659 11.1588 10.7724H9.93662L14.1044 15.2502C14.2357 15.3909 14.3001 15.5733 14.2835 15.7572C14.2669 15.9411 14.1706 16.1114 14.0158 16.2308C13.861 16.3501 13.6604 16.4087 13.4581 16.3936C13.2558 16.3785 13.0685 16.2909 12.9372 16.1502L7.71828 10.5224C7.62197 10.4197 7.56067 10.2937 7.54186 10.1599C7.52306 10.026 7.54757 9.89006 7.6124 9.76865C7.67723 9.64724 7.77957 9.54563 7.9069 9.47625C8.03424 9.40687 8.18105 9.37273 8.32939 9.37799H11.2077C11.7886 9.36202 12.3387 9.13719 12.7375 8.75286C13.1362 8.36852 13.3508 7.85608 13.3344 7.32799V7.21688H7.83439C7.67232 7.21688 7.51688 7.15835 7.40227 7.05417C7.28767 6.94998 7.22328 6.80867 7.22328 6.66133C7.22328 6.51399 7.28767 6.37268 7.40227 6.26849C7.51688 6.1643 7.67232 6.10577 7.83439 6.10577H12.9188C12.7306 5.8526 12.4778 5.64459 12.1819 5.49949C11.8861 5.35438 11.5561 5.27648 11.22 5.27244H7.79162C7.58902 5.27244 7.39472 5.19927 7.25147 5.06904C7.10821 4.93881 7.02773 4.76217 7.02773 4.57799C7.02773 4.39382 7.10821 4.21718 7.25147 4.08695C7.39472 3.95671 7.58902 3.88355 7.79162 3.88355H15.8888C16.0509 3.88355 16.2064 3.94208 16.321 4.04627C16.4356 4.15046 16.5 4.29176 16.5 4.43911C16.5 4.58645 16.4356 4.72776 16.321 4.83194C16.2064 4.93613 16.0509 4.99466 15.8888 4.99466H13.86C14.1798 5.32141 14.4287 5.70032 14.5933 6.11133V6.11133Z"
                          fill="white"
                        />
                      </svg>
                    </div>

                    <h2 className="text-h2 tracking-wide text-tertiary-dark font-semibold">
                      &#8377;{Math.floor(credit?.myBalance)}
                    </h2>
                  </div>
                  <p className="mt-1 text-h5 font-semibold tracking-wide text-secondary-dark">
                    Total Balance
                  </p>
                </div>
                {/* <div className="relative flex justify-center items-center">
                  <p className="text-xs absolute -left-4 -top-1 text-tertiary-dark flex items-center">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 14V7"
                        stroke="#702963"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15 10.0625L18 7L21 10.0625"
                        stroke="#702963"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    12%
                  </p>
                  <svg
                    width="74"
                    height="44"
                    viewBox="0 0 74 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_d_1588_5036)">
                      <path
                        d="M4.94499 35.0443L20.5948 31.6844C21.8661 31.4115 22.8168 30.3507 22.9494 29.0572L24.0858 17.9735C24.3969 14.9389 27.3296 12.8877 30.2869 13.6364L35.0833 14.8508C37.8843 15.5599 40.7015 13.7543 41.2271 10.9132L42.2103 5.59808C42.7359 2.75697 45.5531 0.951378 48.3541 1.66051L57.6743 4.02018C58.6427 4.26538 59.6625 4.21483 60.602 3.87505L69.6579 0.599808"
                        stroke="#702963"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_1588_5036"
                        x="0.840088"
                        y="0.129395"
                        width="72.9878"
                        height="43.4038"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.227451 0 0 0 0 0.137255 0 0 0 0 0.415686 0 0 0 0.48 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_1588_5036"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_1588_5036"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div> */}
              </div>
              <BtnBlock
                onClick={(e) =>
                  setModals((prevState) => ({ ...prevState, addCredit: true }))
                }
              >
                Add Tokens
              </BtnBlock>
            </div>
            <div className="rounded-sm w-[calc(100%-354px)] md:h-[345px] relative max-w-wallet-graph h-full bg-primary-extra-light border-primary-dark-20 border-1 border-solid">
              <div className="flex flex-row mx-4 absolute right-1 top-1 ">
                <p className="text-secondary-light mt-[1px] mr-2">Sort by</p>
                <div className="flex flex-col relative group">
                  <button
                    // onClick={() => setFilterYear(true)}
                    className="flex justify-between px-2 gap-6 items-center bg-neutral-10 w-[100px] h-6 text-secondary-dark text-mobile-p1 sm:text-tablet-p1 lg:text-p1 font-semibold"
                  >
                    <span>{renderYear == "" ? CurrentYear : renderYear}</span>
                    <span className="ml-0">
                      <svg
                        width="18"
                        height="15"
                        viewBox="0 0 18 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="18" height="15" rx="2" fill="#FFD600" />
                        <path d="M9.5 11L5 5H14L9.5 11Z" fill="#7A7976" />
                      </svg>
                    </span>
                  </button>
                  <div
                    className={`${filterYear ? "flex" : "hidden"
                      } hidden group-hover:flex overflow-y-scroll flex-col absolute top-[23px] left-0 bg-primary-white max-h-[100px] h-fit w-[100px] scrollbar `}
                  >
                    {year.map((value, index) => (
                      <span
                        onClick={() => changeYear(value)}
                        className="w-full cursor-pointer capitalize bg-[#fff] text-secondary-light p-2 hover:bg-[#f0f0f0] text-left h-8 flex items-center text-p1"
                      >
                        {value}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              <Bar width={divStyle} options={options} data={data} style={{ height: "342pxm !important" }} className="bar-height" />

            </div>
          </div>
          <div className="my-8 px-8 py-10 rounded-sm w-full max-w-[1400px] bg-primary-extra-light border-primary-dark-20 border-1 border-solid">
            <div className="w-full flex items-center justify-between">
              <h2 className="text-heading text-h4 font-bold">
                Transaction History
              </h2>
              <div className="flex">
                <div className="flex flex-row mx-4">
                  <p className="text-secondary-light mt-1 mr-4">Filter by</p>
                  <div className="flex flex-col relative group">
                    <button
                      onClick={() => setFilterSort(true)}
                      className="flex justify-between px-2 gap-6 items-center bg-neutral-10 w-[300px] h-8 text-secondary-dark text-mobile-p1 sm:text-tablet-p1 lg:text-p1 font-semibold"
                    >
                      <span>{filterData}</span>
                      <span className="ml-2">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 18 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="18" height="15" rx="2" fill="#FFD600" />
                          <path d="M9.5 11L5 5H14L9.5 11Z" fill="#7A7976" />
                        </svg>
                      </span>
                    </button>
                    <div
                      className={`${flterSort ? "flex" : "hidden"
                        } hidden group-hover:flex overflow-y-scroll flex-col absolute top-[33px] left-0 bg-primary-white max-h-[300px] h-fit w-[300px] scrollbar `}
                    >
                      {filterValue.map((value, index) => (
                        <span
                          onClick={() => changeData(value)}
                          className="w-full cursor-pointer capitalize bg-[#fff] text-secondary-light p-2 hover:bg-[#f0f0f0] text-left h-8 flex items-center text-p1"
                        >
                          {value}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="flex flex-row mx-4">
                  <p className="text-secondary-light mt-1 mr-4">Sort by</p>
                  <div className="flex flex-col relative group">
                    <button
                      onClick={() => setFilterSort(true)}
                      className="flex justify-between px-2 gap-6 items-center bg-neutral-10 w-[150px] h-8 text-secondary-dark text-mobile-p1 sm:text-tablet-p1 lg:text-p1 font-semibold"
                    >
                      <span>{filterDataTwo}</span>
                      <span className="ml-2">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 18 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="18" height="15" rx="2" fill="#FFD600" />
                          <path d="M9.5 11L5 5H14L9.5 11Z" fill="#7A7976" />
                        </svg>
                      </span>
                    </button>
                    <div
                      className={`${flterSort ? "flex" : "hidden"
                        } hidden group-hover:flex overflow-y-scroll flex-col absolute top-[33px] left-0 bg-primary-white max-h-[300px] h-fit w-[150px] scrollbar `}
                    >
                      {filterValueTwo.map((value, index) => (
                        <span
                          onClick={() => changeDataTwo(value)}
                          className="w-full cursor-pointer  capitalize bg-[#fff] text-secondary-light p-2 hover:bg-[#f0f0f0] text-left h-8 flex items-center text-p1"
                        >
                          {value}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                {/* <button className="rounded-sm mr-4 flex bg-[#eaeaea] text-secondary-light justify-between items-center py-1 px-2 w-48 h-8">
                  Download Report
                  <svg
                    width="19"
                    height="17"
                    viewBox="0 0 19 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.042 12.75H3.95866C3.52143 12.75 3.16699 13.0671 3.16699 13.4583C3.16699 13.8495 3.52143 14.1667 3.95866 14.1667H15.042C15.4792 14.1667 15.8337 13.8495 15.8337 13.4583C15.8337 13.0671 15.4792 12.75 15.042 12.75Z"
                      fill="#702963"
                    />
                    <path
                      d="M3.16699 12.0415V13.4582C3.16699 13.8494 3.52143 14.1665 3.95866 14.1665C4.39588 14.1665 4.75033 13.8494 4.75033 13.4582V12.0415C4.75033 11.6503 4.39588 11.3332 3.95866 11.3332C3.52143 11.3332 3.16699 11.6503 3.16699 12.0415Z"
                      fill="#702963"
                    />
                    <path
                      d="M14.25 12.0415V13.4582C14.25 13.8494 14.6044 14.1665 15.0417 14.1665C15.4789 14.1665 15.8333 13.8494 15.8333 13.4582V12.0415C15.8333 11.6503 15.4789 11.3332 15.0417 11.3332C14.6044 11.3332 14.25 11.6503 14.25 12.0415Z"
                      fill="#702963"
                    />
                    <path
                      d="M9.49998 10.6252C9.33586 10.6263 9.1754 10.5817 9.04082 10.4977L5.87415 8.50017C5.70347 8.39184 5.58768 8.22745 5.55207 8.04295C5.51647 7.85845 5.56396 7.66885 5.68415 7.51558C5.74415 7.43897 5.82051 7.37376 5.90883 7.3237C5.99715 7.27364 6.09567 7.23973 6.19872 7.22392C6.30177 7.20812 6.40729 7.21073 6.5092 7.23161C6.61111 7.25249 6.70739 7.29123 6.79248 7.34558L9.49998 9.0385L12.1916 7.22517C12.3596 7.11245 12.5708 7.06405 12.7786 7.09062C12.9865 7.11719 13.174 7.21654 13.3 7.36683C13.426 7.51712 13.4801 7.70603 13.4504 7.89201C13.4207 8.07798 13.3096 8.24578 13.1417 8.3585L9.97498 10.4835C9.83795 10.5755 9.67128 10.6252 9.49998 10.6252Z"
                      fill="#702963"
                    />
                    <path
                      d="M9.50065 9.20833C9.29069 9.20833 9.08932 9.13371 8.94086 9.00087C8.79239 8.86803 8.70898 8.68786 8.70898 8.5V2.83333C8.70898 2.64547 8.79239 2.4653 8.94086 2.33247C9.08932 2.19963 9.29069 2.125 9.50065 2.125C9.71061 2.125 9.91198 2.19963 10.0604 2.33247C10.2089 2.4653 10.2923 2.64547 10.2923 2.83333V8.5C10.2923 8.68786 10.2089 8.86803 10.0604 9.00087C9.91198 9.13371 9.71061 9.20833 9.50065 9.20833Z"
                      fill="#702963"
                    />
                  </svg>
                </button> */}
                <div className="flex justify-between items-center w-24">
                  <button
                    onClick={() => {
                      prevPaginationPage();
                    }}
                  >
                    <svg
                      width="21"
                      height="19"
                      viewBox="0 0 21 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.8728 16.2351L14.1648 15.1379L7.54586 9.50302L14.1729 3.87542L12.8824 2.7768L5.00495 9.50162L12.8728 16.2351Z"
                        fill="#702963"
                      />
                    </svg>
                  </button>
                  <p className="text-p1 text-secondary-light">
                    {pageNation} - {totalPages()}
                  </p>
                  <button
                    onClick={() => {
                      nextPaginationPage();
                    }}
                  >
                    <svg
                      width="21"
                      height="18"
                      viewBox="0 0 21 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.1359 15.2366L5.84345 14.1394L12.4644 8.50448L5.83541 2.87689L7.12629 1.77826L15.0061 8.50308L7.1359 15.2366Z"
                        fill="#702963"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>{" "}
            {/* transaction history end */}
            {/* <p className="text-secondary-light text-p1 text-left my-2">
              29 September 2021
            </p> */}
            <div className="py-4 ">
              {transaction?.length === 0 ? (
                <div className="flex flex-col items-center justify-center w-full h-[70%]">
                  <p className="text-secondary-light text-montserrat font-semibold leading-[29px] text-h1">
                    Transaction History is Empty.
                  </p>
                </div>
              ) : (
                transaction?.map((history, index) => (
                  <div
                    key={history.id}
                    className="flex items-center justify-between mb-6 last:mb-0"
                  >
                    <div>
                      {history.creditOrDebit === "debit" && (
                        <svg
                          width="52"
                          height="49"
                          viewBox="0 0 52 49"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M51.75 24.5C51.75 37.8791 40.2355 48.75 26 48.75C11.7645 48.75 0.25 37.8791 0.25 24.5C0.25 11.1209 11.7645 0.25 26 0.25C40.2355 0.25 51.75 11.1209 51.75 24.5Z"
                            fill="#F7F7F7"
                            stroke="#E4E4E4"
                            strokeWidth="0.5"
                          />
                          <rect
                            x="10.5"
                            y="13.1665"
                            width="29.9093"
                            height="24.3333"
                            rx="2.5"
                            fill="#DEA8D4"
                            fillOpacity="0.14"
                            stroke="#D32EB5"
                          />
                          <path
                            d="M21.3633 27.0183C21.5146 28.503 22.9107 29.5566 25.0359 29.6929V30.7759H26.1026V29.6929C28.4242 29.5335 29.8643 28.4122 29.8643 26.7538C29.8643 25.3377 28.8957 24.5183 26.841 24.057L26.1026 23.8905V20.5043C27.2501 20.6023 28.0244 21.1402 28.2197 21.9435H29.7231C29.5533 20.5186 28.1481 19.4961 26.1026 19.383V18.3071H25.0359V19.4053C23.0528 19.6101 21.6916 20.7163 21.6916 22.2161C21.6916 23.511 22.6795 24.4275 24.4131 24.814L25.0369 24.9583V28.5484C23.8618 28.397 23.0528 27.8359 22.8575 27.0183H21.3633ZM24.8314 23.6019C23.7647 23.3677 23.195 22.8671 23.195 22.1626C23.195 21.3219 23.915 20.7011 25.0359 20.5346V23.6473L24.8314 23.6028V23.6019ZM26.4585 25.2691C27.7748 25.5568 28.3527 26.0342 28.3527 26.8447C28.3527 27.8217 27.5079 28.4727 26.1026 28.5716V25.1917L26.4585 25.2683V25.2691Z"
                            fill="#D32EB5"
                          />
                          <ellipse
                            cx="36.3635"
                            cy="12.6668"
                            rx="8.18188"
                            ry="6.33333"
                            fill="#F6F6F6"
                          />
                          <path
                            d="M36.3638 7.91683V15.8335"
                            stroke="#D32EB5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M31.8181 11.3804L36.3636 7.91683L40.9091 11.3804"
                            stroke="#D32EB5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                      {history.creditOrDebit === "credit" && (
                        <svg
                          width="40"
                          height="38"
                          viewBox="0 0 40 38"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.5"
                            y="13.166"
                            width="29.9094"
                            height="24.3333"
                            rx="2.5"
                            fill="#37ABFF"
                            fill-opacity="0.14"
                            stroke="#37ABFF"
                          />
                          <path
                            d="M11.3635 27.0178C11.5149 28.5025 12.9109 29.5561 15.0362 29.6924V30.7754H16.1029V29.6924C18.4245 29.533 19.8645 28.4117 19.8645 26.7533C19.8645 25.3372 18.896 24.5179 16.8413 24.0565L16.1029 23.89V20.5038C17.2504 20.6018 18.0246 21.1397 18.2199 21.9431H19.7234C19.5536 20.5181 18.1484 19.4956 16.1029 19.3825V18.3066H15.0362V19.4048C13.0531 19.6096 11.6918 20.7158 11.6918 22.2156C11.6918 23.5106 12.6798 24.427 14.4133 24.8135L15.0372 24.9578V28.5479C13.8621 28.3965 13.0531 27.8354 12.8577 27.0178H11.3635ZM14.8316 23.6014C13.7649 23.3672 13.1952 22.8666 13.1952 22.1622C13.1952 21.3214 13.9153 20.7006 15.0362 20.5341V23.6468L14.8316 23.6023V23.6014ZM16.4588 25.2687C17.7751 25.5563 18.3529 26.0337 18.3529 26.8442C18.3529 27.8212 17.5081 28.4722 16.1029 28.5711V25.1912L16.4588 25.2678V25.2687Z"
                            fill="#37ABFF"
                          />
                          <ellipse
                            cx="26.3635"
                            cy="12.6673"
                            rx="8.18189"
                            ry="6.33333"
                            fill="#F6F6F6"
                          />
                          <path
                            d="M26.364 15.8327V7.91602"
                            stroke="#37ABFF"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M21.8181 12.3691L26.3636 15.8327L30.9091 12.3691"
                            stroke="#37ABFF"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      )}
                    </div>
                    <div className="flex justify-between w-[calc(100%-125px)] mx-4">
                      <div className="flex w-[calc(100%-246px)] flex-col items-start justify-center">
                        <h4 className="w-full overflow-hidden whitespace-nowrap text-[#5C5757] text-ellipsis font-semibold text-h4">
                          {renderHeading(history.typesOfTransactions)}
                        </h4>
                        <p className="text-secondary-light text-h5 font-[500]">
                          {getTime(history.createdAt)} ago
                        </p>
                      </div>
                      <div className="flex flex-col items-end min-w-[186px] ml-10">
                        <h4 className="text-[#D32EB5] font-semibold text-h4">
                          {(history.credits * 1).toFixed(2)}
                        </h4>
                        <p className="text-secondary-light text-h5 font-[500]">
                          Closing Balance:
                          {(history.remainingCredits * 1).toFixed(2)}
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        openDetailPage(history);
                      }}
                      className="text-[#969696] underline"
                    >
                      View
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>
          {modals.addCredit && (
            <DialogBox show={modals.addCredit}>
              <div className="bg-primary-white flex flex-col justify-between relative w-pop-up  p-6">
                <h4 className="text-h4 text-tertiary-dark font-bold">
                  Add Tokens
                </h4>
                <p className='mt-1 mb-5' >To add token contact admin@eprakashak.in</p>
                <BtnSmall
                  onClick={() => {
                    setModals({ ...modals, addCredit: false })
                  }}
                >
                  Okay
                </BtnSmall>
                {/* <p className="text-p1 text-left my-4 text-secondary-dark">
                  1 Tokens = &#8377; 1
                </p>

                <h5 className="text-h5 text-left text-heading mb-4 font-semibold">
                  Available Tokens: {Math.floor(credit?.myCredits?.credits)}
                </h5>

                <p className="mb-4 text-p1 text-left text-heading ">Select :</p>
                <div>
                  {creditOption.map((item, i) =>
                    !item.selected ? (
                      <button
                        key={i}
                        onClick={() => {
                          setCreditOption((prevState) => {
                            prevState.forEach((option, j) =>
                              i !== j
                                ? (option.selected = false)
                                : (option.selected = true)
                            );
                            return [...prevState];
                          });
                          setInputValue(item?.amount);
                        }}
                        className="hover:border-primary-dark mr-2 mb-2 w-[95px] h-[45px] text-heading border-1 border-solid border-primary-dark-20"
                      >
                        {item.amount}
                      </button>
                    ) : (
                      <button
                        key={i}
                        disabled
                        className="bg-primary-dark mr-2 mb-2 w-[95px] h-[45px] text-primary-white border-1 border-solid border-primary-dark-20"
                      >
                        {item.amount}
                      </button>
                    )
                  )}
                </div>
                <label
                  for="credit"
                  className="text-heading font-semibold text-left my-4"
                >
                  Enter No. of Tokens (eg:100)
                </label>
                <div className="flex items-center">
                  <input
                    className="w-52 h-12 pl-4 outline-0 border-1 border-solid border-primary-dark-20"
                    type="number"
                    placeholder="&#8377;100"
                    value={inputValue}
                    onChange={(e) => e.target.value >= 1 ? setInputValue(e.target.value) : setInputValue("")}
                  />
                  <p className="ml-2 text-tertiary-dark text-h5">
                    = &#8377;{inputValue ? inputValue : 0}
                  </p>
                </div>

                <p className="my-2 text-secondary-light text-[14px] text-left w-52">
                  *Each Token is worth &#8377;1.
                </p>

                <div className="w-full text-right">
                  <BtnSmall
                    onClick={() => {
                      addcreaditsinacc();
                      setIsLoading(true);
                    }}
                  >
                    Confirm
                  </BtnSmall>
                </div> */}

                <button
                  onClick={() =>
                    setModals((prevState) => ({
                      ...prevState,
                      addCredit: false,
                    }))
                  }
                  className="absolute top-8 right-8"
                >
                  <svg
                    width="12"
                    height="14"
                    viewBox="0 0 12 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                      fill="black"
                      fillOpacity="0.53"
                    />
                  </svg>
                </button>
              </div>
            </DialogBox>
          )}

          <DialogBox show={modals.tranDetail}>
            {modals.transDetailType ? (
              <div className="bg-primary-white flex flex-col relative  p-6 w-[600px] h-fit max-h-[296px] ">
                <h4 className="text-h4 text-tertiary-dark font-bold">
                  {pickedHistory.typesOfTransactions == "hostingCharge"
                    ? "Hosting Charge"
                    : "Conversion Charges"}
                </h4>
                <div className="flex w-full gap-3 flex-col mt-8 ">
                  <div className="w-full flex items-center  ">
                    <p className="text-[#5f5d5dc0] w-[239px]">Book Title</p>
                    <p className="text-[#000000da] ">
                      {pickedHistory?.details.metadata[0].title}
                    </p>
                  </div>
                  <div className="w-full flex items-center  ">
                    <p className="text-[#5f5d5dc0] w-[239px]">Validity</p>
                    <p className="text-[#000000da] ">
                      {pickedHistory?.details.metadata[0].validity}
                    </p>
                  </div>
                  <div className="w-full flex items-center  ">
                    <p className="text-[#5f5d5dc0] w-[239px]">Total Charge</p>
                    <p className="text-[#000000da] ">
                      {(pickedHistory?.credits * 1).toFixed(2)} Tokens
                    </p>
                  </div>
                </div>
                <div className="w-full flex justify-end mt-5 ">
                  <BtnSmall
                    onClick={() =>
                      setModals((prev) => ({ ...prev, tranDetail: false }))
                    }
                  >Go Back</BtnSmall>
                </div>
                <button
                  onClick={() =>
                    setModals((prev) => ({ ...prev, tranDetail: false }))
                  }
                  className="absolute top-6 right-6 "
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.6524 13.3035C12.3599 13.596 11.9631 13.7604 11.5494 13.7604C11.1356 13.7604 10.7389 13.596 10.4463 13.3035L7.00001 9.36448L3.55371 13.3022C3.40928 13.449 3.23722 13.5657 3.04745 13.6457C2.85768 13.7257 2.65395 13.7673 2.44802 13.7681C2.24209 13.7689 2.03804 13.729 1.84762 13.6506C1.65721 13.5722 1.4842 13.4568 1.33858 13.3112C1.19297 13.1656 1.07763 12.9926 0.999207 12.8022C0.920788 12.6117 0.880845 12.4077 0.881684 12.2018C0.882522 11.9958 0.924125 11.7921 1.00409 11.6023C1.08406 11.4126 1.20081 11.2405 1.3476 11.0961L4.93301 7.00108L1.3463 2.90348C1.19951 2.75905 1.08276 2.58699 1.00279 2.39722C0.922825 2.20745 0.881223 2.00373 0.880384 1.7978C0.879546 1.59187 0.919488 1.38781 0.997907 1.19739C1.07633 1.00698 1.19167 0.833974 1.33728 0.688359C1.4829 0.542743 1.65591 0.4274 1.84632 0.348981C2.03674 0.270562 2.24079 0.23062 2.44672 0.231458C2.65265 0.232297 2.85638 0.273899 3.04615 0.353866C3.23592 0.433833 3.40798 0.550582 3.55241 0.697379L7.00001 4.63768L10.4463 0.697379C10.5907 0.550582 10.7628 0.433833 10.9526 0.353866C11.1423 0.273899 11.3461 0.232297 11.552 0.231458C11.7579 0.23062 11.962 0.270562 12.1524 0.348981C12.3428 0.4274 12.5158 0.542743 12.6614 0.688359C12.807 0.833974 12.9224 1.00698 13.0008 1.19739C13.0792 1.38781 13.1192 1.59187 13.1183 1.7978C13.1175 2.00373 13.0759 2.20745 12.9959 2.39722C12.916 2.58699 12.7992 2.75905 12.6524 2.90348L9.06701 7.00108L12.6524 11.0961C12.7974 11.241 12.9125 11.413 12.991 11.6024C13.0695 11.7918 13.1099 11.9948 13.1099 12.1998C13.1099 12.4048 13.0695 12.6078 12.991 12.7972C12.9125 12.9865 12.7974 13.1586 12.6524 13.3035Z"
                      fill="black"
                      fill-opacity="0.53"
                    />
                  </svg>
                </button>
              </div>
            ) : (
              <div className="bg-primary-white flex flex-col relative  p-6 w-[600px] h-fit ">
                <h4 className="text-h4 text-tertiary-dark font-bold">
                  {pickedHistory?.typesOfTransactions === "generateAccessIds"
                    ? "Access IDs - Books"
                    : pickedHistory?.typesOfTransactions ===
                      "addUnusedAccessIds"
                      ? "Tokens of unused access IDs - Books"
                      : pickedHistory?.typesOfTransactions === "setHostingCharge"
                        ? "Set Hosting Charges"
                        : pickedHistory?.typesOfTransactions === "setAccessIds"
                          ? "Access IDs - Sets"
                          : null}{" "}
                </h4>
                <div className="flex w-full gap-3 flex-col mt-8 ">
                  <div className="w-full flex items-center  ">
                    <p className="text-[#5f5d5dc0] w-[180px]">Total Charges</p>
                    <p className="text-[#000000da] ">
                      {(pickedHistory?.credits * 1).toFixed(2)} Tokens
                    </p>
                  </div>
                  <div className="h-fit max-h-[300px] overflow-hidden overflow-y-scroll scrollbar flex w-full gap-3 flex-col  ">
                    {pickedHistory?.details?.metadata.map((data, index) => (
                      <div
                        key={data.id}
                        className="p-2 px-4 w-full bg-[#FBFAFB] h-[98px] border-1 border-[#aeaeae] border-solid shadow-sm "
                      >
                        <p className="text-[#0C0B0C] text-[18px] font-[600] ">
                          {data.title}{" "}
                        </p>
                        <div className="flex flex-row justify-start gap-10 mt-4">
                          <p className="">
                            <span className="text-[#5f5d5dc0] w-[239px] mr-3">
                              Validity
                            </span>
                            <span className="text-[#000000da] ">{data?.validity} {pickedHistory?.details?.setData?.validity} year</span>
                          </p>
                          {data?.accessId && (<p className="">
                            <span className="text-[#5f5d5dc0] w-[239px] mr-3">
                              No. of Access IDs
                            </span>
                            <span className="text-[#000000da] ">{data?.accessId}</span>
                          </p>)}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="w-full flex justify-end mt-2 ">
                    <BtnSmall
                      onClick={() =>
                        setModals((prev) => ({ ...prev, tranDetail: false }))
                      }
                    >
                      Go Back
                    </BtnSmall>
                  </div>
                </div>
                <button
                  onClick={() =>
                    setModals((prev) => ({ ...prev, tranDetail: false }))
                  }
                  className="absolute top-6 right-6 "
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.6524 13.3035C12.3599 13.596 11.9631 13.7604 11.5494 13.7604C11.1356 13.7604 10.7389 13.596 10.4463 13.3035L7.00001 9.36448L3.55371 13.3022C3.40928 13.449 3.23722 13.5657 3.04745 13.6457C2.85768 13.7257 2.65395 13.7673 2.44802 13.7681C2.24209 13.7689 2.03804 13.729 1.84762 13.6506C1.65721 13.5722 1.4842 13.4568 1.33858 13.3112C1.19297 13.1656 1.07763 12.9926 0.999207 12.8022C0.920788 12.6117 0.880845 12.4077 0.881684 12.2018C0.882522 11.9958 0.924125 11.7921 1.00409 11.6023C1.08406 11.4126 1.20081 11.2405 1.3476 11.0961L4.93301 7.00108L1.3463 2.90348C1.19951 2.75905 1.08276 2.58699 1.00279 2.39722C0.922825 2.20745 0.881223 2.00373 0.880384 1.7978C0.879546 1.59187 0.919488 1.38781 0.997907 1.19739C1.07633 1.00698 1.19167 0.833974 1.33728 0.688359C1.4829 0.542743 1.65591 0.4274 1.84632 0.348981C2.03674 0.270562 2.24079 0.23062 2.44672 0.231458C2.65265 0.232297 2.85638 0.273899 3.04615 0.353866C3.23592 0.433833 3.40798 0.550582 3.55241 0.697379L7.00001 4.63768L10.4463 0.697379C10.5907 0.550582 10.7628 0.433833 10.9526 0.353866C11.1423 0.273899 11.3461 0.232297 11.552 0.231458C11.7579 0.23062 11.962 0.270562 12.1524 0.348981C12.3428 0.4274 12.5158 0.542743 12.6614 0.688359C12.807 0.833974 12.9224 1.00698 13.0008 1.19739C13.0792 1.38781 13.1192 1.59187 13.1183 1.7978C13.1175 2.00373 13.0759 2.20745 12.9959 2.39722C12.916 2.58699 12.7992 2.75905 12.6524 2.90348L9.06701 7.00108L12.6524 11.0961C12.7974 11.241 12.9125 11.413 12.991 11.6024C13.0695 11.7918 13.1099 11.9948 13.1099 12.1998C13.1099 12.4048 13.0695 12.6078 12.991 12.7972C12.9125 12.9865 12.7974 13.1586 12.6524 13.3035Z"
                      fill="black"
                      fill-opacity="0.53"
                    />
                  </svg>
                </button>
              </div>
            )}
          </DialogBox>
          <DialogBox show={paymentSuccessfull}>
            <PopUp
              height={true}
              style={{ bottom: "0px" }}
              onClick={() => {
                setPaymentSuccessfull(false);
              }}
              onClose={() => {
                setPaymentSuccessfull(false);
              }}
              button="Close"
              title="Payment Successfully!"
              body="Please check your registered email address for an invoice of this transaction."
            />
          </DialogBox>
        </>
      )}
    </Page>
  );
}
